import store from '@/store/index.js'

const assignOnBoardingStep = (data) => {
    let step = 1
    const kyc = data.kyc
    const userDetails = data.user.userDetails
    store.dispatch('onBoarding/setField', { field: 'Name', value: userDetails.name ? userDetails.name : '' })
    store.dispatch('onBoarding/setField', { field: 'dob', value: userDetails?.dob })
    try {
        if (userDetails.isEmailVerified) {
            step++
            store.dispatch('onBoarding/setField', { field: 'Email', value: userDetails.emailId })
        }
        if (kyc.aadhaar.isVerified) {
            step = 3
            store.dispatch('onBoarding/setField', { field: 'Name', value: userDetails.name })
            store.dispatch('onBoarding/setField', { field: 'Aadhaar', value: kyc.aadhaar.value })

            if (kyc.pan.isVerified) {
                step++
                store.dispatch('onBoarding/setField', { field: 'Pan', value: kyc.pan.value })

                if (kyc.bankAccount.isVerified) {
                    step++
                    store.dispatch('onBoarding/setField', { field: 'Bank Account Number', value: kyc.bankAccount.bankAccountNumber })

                    if (userDetails?.isPortfolioExisting) {
                        step = 5
                        store.dispatch('onBoarding/setField', { field: 'isPortfolioExisting', value: true })
                        if (userDetails?.isPortfolioPaid) {
                            step = 7
                            store.dispatch('onBoarding/setField', { field: 'isPortfolioPaid', value: true })
                        }
                    }
                }
            }
        }
        return step
    } catch (err) {
        return step
    }
}

const setCookie = (cookieName, cookieValue, exp) => {
    const date = new Date()
    date.setTime(date.getTime() + (exp) * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + '; path=/'
}

function getCookie (cookieName) {
    const name = cookieName + '='
    const cookieDecoded = decodeURIComponent(document.cookie)
    const cArr = cookieDecoded.split('; ')
    let res
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length)
    })
    return res
}

function logoutCookies () {
    setCookie('token', '', -1)
    window.localStorage.clear()
}

const setLocalStorage = (key, value) => {
    localStorage[key] = value
}

const clearLocalStorage = (key) => {
    localStorage.clear(key)
}

const getLocalStorage = (key) => {
    return localStorage.getItem(key)
}

const selectText = (element) => {
    let range
    if (document.selection) {
        // IE
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
    } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
    }
}

const copyToClipboard = (element) => {
    selectText(element)
    document.execCommand('copy')
}

const isDate = (date) => {
    return (new Date(date) !== 'Invalid Date') && !isNaN(new Date(date))
}

export {
    isDate,
    assignOnBoardingStep,
    setCookie, getCookie,
    logoutCookies,
    setLocalStorage,
    clearLocalStorage, getLocalStorage,
    copyToClipboard
}
